import type { IModalsState } from "app/pages/digital-suite/home-page/components/InviteUsers/types";
import { useState } from "react";

const useModalsState = (
    initialState: IModalsState,
): [IModalsState, (key: keyof IModalsState, value: boolean) => void] => {
    const [modalsState, setModalsState] = useState<IModalsState>(initialState);

    const setModalState = (key: keyof IModalsState, value: boolean) => {
        setModalsState((prevState) => ({
            ...prevState,
            [key]: value,
        }));
    };

    return [modalsState, setModalState];
};

export default useModalsState;
